import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from "react-router-dom";

const DoctorSchedule = ({ klinik, haripoli }) => {
  // Tambahan: fungsi untuk mendapatkan hari sesuai zona Jakarta
  const getTodayJakarta = () => {
    const jakartaTime = new Date().toLocaleString("en-US", { timeZone: "Asia/Jakarta" });
    const day = new Date(jakartaTime).getDay(); // 0 = Minggu, 1 = Senin, ..., 6 = Sabtu
    const days = ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu'];
    const today = days[day];
    return today === 'Minggu' ? 'Senin' : today;
  };

  const [selectedDay, setSelectedDay] = useState(getTodayJakarta()); // Default ke hari ini atau Senin jika Minggu
  const [selectedPoli, setSelectedPoli] = useState('Semua Klinik');

  const handleDayChange = (event) => {
    setSelectedDay(event.target.value);
  };

  const handlePoliChange = (event) => {
    setSelectedPoli(event.target.value);
  };

  const filteredSchedule = haripoli.filter(hp => 
    (selectedPoli === 'Semua Klinik' || hp.nama_ruangan === selectedPoli) &&
    hp.hari_kerja === selectedDay
  );

  return (
    <div className="container text-center my-4">
      <div className="row justify-content-center">
        <div className="col-lg-8">
          <div className="card bg-light mb-3">
            <div className="card-header text-center">
              <h4>Pilih Hari dan Klinik</h4>
            </div>
            <div className="card-header">
              <form>
                <div className="mb-3">
                  <select
                    name="hari_kerja"
                    className="form-select"
                    value={selectedDay}
                    onChange={handleDayChange}
                  >
                    <option value="Senin">Senin</option>
                    <option value="Selasa">Selasa</option>
                    <option value="Rabu">Rabu</option>
                    <option value="Kamis">Kamis</option>
                    <option value="Jumat">Jumat</option>
                    <option value="Sabtu">Sabtu</option>
                  </select>
                </div>
                <div className="mb-3">
                  <select
                    name="pilih_poli"
                    className="form-select"
                    value={selectedPoli}
                    onChange={handlePoliChange}
                  >
                    <option value="Semua Klinik">Semua Klinik</option>
                    {klinik.map((k, index) => (
                      <option key={index} value={k.nama_ruangan}>
                        {k.nama_ruangan}
                      </option>
                    ))}
                  </select>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="table-responsive">
        <table className="table table-hover">
          <thead>
            <tr>
              <th>Klinik</th>
              <th>Nama Dokter</th>
              <th>Jam Praktek</th>
            </tr>
          </thead>
          <tbody>
            {filteredSchedule.length > 0 ? (
              filteredSchedule.map((hp, index) => (
                <tr key={index}>
                  <td>{hp.nama_ruangan}</td>
                  <td>{hp.nm_dokter}</td>
                  <td>{hp.jam_mulai} - {hp.jam_selesai}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3">Tidak ada jadwal untuk hari ini.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const Main = () => {
  const [klinik, setKlinik] = useState([]);
  const [haripoli, setHaripoli] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const klinikResponse = await axios.get('https://simanap.rsudkotajambi.id:5000/api/klinik');
        const haripoliResponse = await axios.get('https://simanap.rsudkotajambi.id:5000/api/jadwal_dokter');
        setKlinik(klinikResponse.data);
        setHaripoli(haripoliResponse.data);
      } catch (err) {
        setError('Error fetching data');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Menangani loading dan error sebelum menampilkan data
  if (loading) return <div id="preloader"></div>;
  if (error) return <div>{error}</div>;

  return (
    <main className="main">
      <div className="page-title dark-background">
        <div className="heading">
          <div className="container">
            <div className="row d-flex justify-content-center text-center">
              <div className="col-lg-8">
                <h1>Jadwal Praktek Dokter Spesialis</h1>
                <p className="mb-0">
                  Jadwal ini mencakup hari, tanggal, dan jam praktik setiap dokter berdasarkan hari dan klinik yang dipilih.
                </p>
              </div>
            </div>
          </div>
        </div>
        <nav className="breadcrumbs">
          <div className="container">
            <ol>
              <li><Link to="/">Home</Link></li>
              <li className="current">Jadwal Dokter</li>
              <li><Link to="/pendaftaran-online">Pendaftaran Online</Link></li>
              <li><Link to="/telemedic">Telemedic</Link></li>
              <li><Link to="/informasi">Informasi</Link></li>
              <li><Link to="/pengaduan">Pengaduan</Link></li>
            </ol>
          </div>
        </nav>
      </div>

      <section id="service-details" className="service-details section">
        <div className="container">
          <div className="row gy-4">
            <div className="col-lg-4" data-aos="fade-up" data-aos-delay="100">
              <div className="services-list">
                <Link to="/bed">Ketersediaan Tempat Tidur</Link>
                <Link to="/jadwal-dokter" className="active">Jadwal Dokter</Link>
                <Link to="/pendaftaran-online">Pendaftaran Online</Link>
                <Link to="/telemedic">Telemedic</Link>
                <Link to="/informasi">Informasi</Link>
                <Link to="/pengaduan">Pengaduan</Link>
              </div>
            </div>

            <div className="col-lg-8" data-aos="fade-up" data-aos-delay="200">
              <DoctorSchedule klinik={klinik} haripoli={haripoli} />
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Main;
